var _defs, _path, _rect, _polygon, _defs2, _path2, _polygon2, _defs3, _path3, _rect2, _polygon3, _polygon4, _polygon5, _path4, _defs4, _path5, _rect3, _polygon6, _defs5, _path6, _path7, _polygon7, _defs6, _path8, _path9, _polygon8, _polygon9, _rect4, _polygon10, _defs7, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _polygon11, _polygon12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRnf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 260 75",
    xmlSpace: "preserve",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    width: 260,
    height: 74.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.2,6.6c0-0.5-0.1-0.8-0.3-1.1c-0.2-0.3-0.4-0.5-0.8-0.7c-0.3-0.2-0.7-0.3-1-0.3c-0.4-0.1-0.8-0.1-1.1-0.1   h-2.6V9h2.3c0.4,0,0.8,0,1.2-0.1c0.4-0.1,0.8-0.2,1.1-0.3c0.3-0.2,0.6-0.4,0.8-0.7C121.1,7.5,121.2,7.1,121.2,6.6 M121.4,20.3   l-4.3-7.9h-1.6v7.9h-4.7V0.5h7.6c1,0,1.9,0.1,2.8,0.3c0.9,0.2,1.7,0.5,2.4,1c0.7,0.5,1.3,1.1,1.7,1.8c0.4,0.8,0.6,1.7,0.6,2.9   c0,1.3-0.4,2.5-1.1,3.4c-0.7,0.9-1.7,1.6-3,2l5.2,8.5H121.4z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 129.4,
    y: 0.5,
    className: "st1",
    width: 4.8,
    height: 19.8
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "150.9,20.3 142.9,7.4 142.8,7.4 142.9,20.3 138.3,20.3 138.3,0.5 143.7,0.5 151.7,13.5 151.8,13.5   151.6,0.5 156.3,0.5 156.3,20.3 "
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 0,
    width: 260,
    height: 74.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M174.6,20.4c-1.3,0.3-2.7,0.5-4.2,0.5c-1.6,0-3-0.3-4.4-0.8c-1.3-0.5-2.5-1.2-3.4-2.1c-1-0.9-1.7-2-2.3-3.3   c-0.5-1.3-0.8-2.7-0.8-4.3c0-1.6,0.3-3,0.8-4.3c0.6-1.3,1.3-2.4,2.3-3.3c1-0.9,2.1-1.6,3.4-2.1c1.3-0.5,2.7-0.7,4.2-0.7   c1.6,0,3,0.2,4.4,0.7c1.3,0.5,2.4,1.1,3.3,1.9l-3,3.4c-0.5-0.5-1.1-1-1.8-1.3c-0.8-0.3-1.6-0.5-2.6-0.5c-0.8,0-1.6,0.2-2.3,0.5   s-1.3,0.7-1.8,1.3c-0.5,0.6-0.9,1.2-1.2,2c-0.3,0.8-0.4,1.6-0.4,2.5c0,0.9,0.1,1.8,0.4,2.5c0.3,0.8,0.6,1.4,1.2,2   c0.5,0.6,1.1,1,1.9,1.3c0.8,0.3,1.6,0.5,2.6,0.5c0.6,0,1.1,0,1.6-0.1c0.5-0.1,1-0.2,1.4-0.4v-3.6h-3.8V8.6h8.2v10.5   C177,19.6,175.9,20,174.6,20.4"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "181.9,20.3 181.9,0.5 195.2,0.5 195.2,4.6 186.5,4.6 186.5,8.3 194.7,8.3 194.7,12.1 186.5,12.1   186.5,16.3 195.7,16.3 195.7,20.3 "
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 0,
    width: 260,
    height: 74.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M209.3,6.6c0-0.5-0.1-0.8-0.3-1.1c-0.2-0.3-0.4-0.5-0.8-0.7c-0.3-0.2-0.7-0.3-1-0.3c-0.4-0.1-0.8-0.1-1.1-0.1   h-2.6V9h2.3c0.4,0,0.8,0,1.2-0.1c0.4-0.1,0.8-0.2,1.1-0.3c0.3-0.2,0.6-0.4,0.8-0.7C209.2,7.5,209.3,7.1,209.3,6.6 M209.5,20.3   l-4.3-7.9h-1.6v7.9h-4.7V0.5h7.6c1,0,1.9,0.1,2.8,0.3c0.9,0.2,1.7,0.5,2.4,1c0.7,0.5,1.3,1.1,1.7,1.8c0.4,0.8,0.6,1.7,0.6,2.9   c0,1.3-0.4,2.5-1.1,3.4c-0.7,0.9-1.7,1.6-3,2l5.2,8.5H209.5z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 217.4,
    y: 0.5,
    className: "st1",
    width: 4.8,
    height: 19.8
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "238.4,20.3 231,11.2 231,11.2 231,20.3 226.3,20.3 226.3,0.5 231,0.5 231,8.6 231.1,8.6 238.1,0.5   244.1,0.5 235.6,9.7 244.6,20.3 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "246.2,0.5 246.2,20.3 260,20.3 260,16.3 250.8,16.3 250.8,12.1 259,12.1 259,8.3 250.8,8.3 250.8,4.6   259.5,4.6 259.5,0.5 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "123.4,47.1 115.5,34.1 115.4,34.1 115.5,47.1 110.8,47.1 110.8,27.3 116.3,27.3 124.2,40.2 124.3,40.2   124.2,27.3 128.9,27.3 128.9,47.1 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M145.3,31.3H145l-4.3,7.6h4.6V31.3z M145.3,47.1v-4.3h-6.5l-2.5,4.3h-5.6l11.6-19.8h15.8v4h-8.3V35h7.9v3.8  h-7.9V43h8.8v4.1H145.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 0,
    width: 260,
    height: 74.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M172.2,33.3c0-0.5-0.1-0.8-0.3-1.1c-0.2-0.3-0.4-0.5-0.8-0.7c-0.3-0.2-0.7-0.3-1-0.3c-0.4-0.1-0.8-0.1-1.1-0.1   h-2.6v4.6h2.3c0.4,0,0.8,0,1.2-0.1c0.4-0.1,0.8-0.2,1.1-0.3c0.3-0.2,0.6-0.4,0.8-0.7C172.1,34.2,172.2,33.8,172.2,33.3 M172.4,47.1   l-4.3-7.9h-1.6v7.9h-4.7V27.3h7.6c1,0,1.9,0.1,2.8,0.3c0.9,0.2,1.7,0.5,2.4,1c0.7,0.5,1.3,1.1,1.7,1.8c0.4,0.8,0.6,1.7,0.6,2.9   c0,1.3-0.4,2.5-1.1,3.4c-0.7,0.9-1.7,1.6-3,2l5.2,8.5H172.4z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 180.4,
    y: 27.3,
    className: "st4",
    width: 4.8,
    height: 19.8
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "201.9,47.1 193.9,34.1 193.8,34.1 193.9,47.1 189.3,47.1 189.3,27.3 194.7,27.3 202.7,40.2 202.7,40.2   202.6,27.3 207.3,27.3 207.3,47.1 "
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: 0,
    width: 260,
    height: 74.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M225.6,47.1c-1.3,0.3-2.7,0.5-4.2,0.5c-1.6,0-3-0.3-4.4-0.8c-1.3-0.5-2.5-1.2-3.4-2.1c-1-0.9-1.7-2-2.3-3.3   c-0.5-1.3-0.8-2.7-0.8-4.3c0-1.6,0.3-3,0.8-4.3c0.6-1.3,1.3-2.4,2.3-3.3c1-0.9,2.1-1.6,3.4-2.1c1.3-0.5,2.7-0.7,4.2-0.7   c1.6,0,3,0.2,4.4,0.7c1.3,0.5,2.4,1.1,3.3,1.9l-3,3.4c-0.5-0.5-1.1-1-1.8-1.3c-0.8-0.3-1.6-0.5-2.6-0.5c-0.8,0-1.6,0.2-2.3,0.5   c-0.7,0.3-1.3,0.7-1.8,1.3c-0.5,0.5-0.9,1.2-1.2,2s-0.4,1.6-0.4,2.5c0,0.9,0.1,1.8,0.4,2.5s0.6,1.4,1.2,2c0.5,0.5,1.1,1,1.9,1.3   c0.8,0.3,1.6,0.5,2.6,0.5c0.6,0,1.1,0,1.6-0.1c0.5-0.1,1-0.2,1.4-0.4v-3.6h-3.8v-3.9h8.2v10.5C228,46.4,226.9,46.8,225.6,47.1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M243.3,32.4c-0.4-0.5-0.9-0.9-1.6-1.2c-0.7-0.3-1.3-0.5-1.9-0.5c-0.3,0-0.6,0-1,0.1c-0.3,0.1-0.6,0.2-0.9,0.3   c-0.3,0.2-0.5,0.4-0.7,0.6c-0.2,0.3-0.3,0.6-0.3,1c0,0.3,0.1,0.6,0.2,0.8c0.1,0.2,0.3,0.4,0.6,0.6c0.3,0.2,0.6,0.3,1,0.5   c0.4,0.1,0.8,0.3,1.3,0.4c0.7,0.2,1.4,0.5,2.1,0.7c0.7,0.3,1.4,0.6,2,1.1c0.6,0.4,1.1,1,1.5,1.7c0.4,0.7,0.6,1.5,0.6,2.5   c0,1.1-0.2,2.1-0.6,3c-0.4,0.8-1,1.5-1.7,2.1c-0.7,0.5-1.5,0.9-2.4,1.2c-0.9,0.3-1.9,0.4-2.8,0.4c-1.4,0-2.8-0.2-4.1-0.7   c-1.3-0.5-2.4-1.2-3.3-2.1l3.1-3.2c0.5,0.6,1.1,1.1,1.9,1.5c0.8,0.4,1.6,0.6,2.4,0.6c0.4,0,0.7,0,1-0.1c0.3-0.1,0.6-0.2,0.9-0.4   c0.3-0.2,0.5-0.4,0.6-0.7c0.1-0.3,0.2-0.6,0.2-1c0-0.4-0.1-0.7-0.3-1c-0.2-0.3-0.5-0.5-0.8-0.7c-0.3-0.2-0.8-0.4-1.3-0.6   c-0.5-0.2-1.1-0.4-1.7-0.6c-0.6-0.2-1.3-0.4-1.9-0.7c-0.6-0.3-1.1-0.6-1.6-1.1c-0.5-0.4-0.9-1-1.1-1.6c-0.3-0.6-0.4-1.4-0.4-2.3   c0-1.1,0.2-2,0.7-2.8c0.4-0.8,1-1.4,1.8-1.9c0.7-0.5,1.5-0.9,2.5-1.1c0.9-0.2,1.8-0.3,2.8-0.3c1.1,0,2.3,0.2,3.4,0.6s2.2,1,3.1,1.8   L243.3,32.4z"
  }))), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "110.7,55.2 110.7,73.8 115.2,73.8 115.2,66.5 122.4,66.5 122.4,62.8 115.2,62.8 115.2,59 123,59   123,55.2 "
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: 0,
    width: 260,
    height: 74.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M140.4,64.4c0-0.8-0.1-1.6-0.4-2.3c-0.3-0.7-0.6-1.3-1.1-1.8c-0.5-0.5-1-0.9-1.7-1.2c-0.7-0.3-1.4-0.4-2.2-0.4   c-0.8,0-1.5,0.1-2.2,0.4c-0.6,0.3-1.2,0.7-1.7,1.2c-0.5,0.5-0.8,1.1-1.1,1.8c-0.3,0.7-0.4,1.5-0.4,2.3c0,0.8,0.1,1.6,0.4,2.3   c0.3,0.7,0.6,1.3,1.1,1.8c0.5,0.5,1,0.9,1.7,1.2c0.6,0.3,1.4,0.4,2.2,0.4c0.8,0,1.5-0.1,2.2-0.4c0.6-0.3,1.2-0.7,1.7-1.2   c0.5-0.5,0.8-1.1,1.1-1.8C140.3,66,140.4,65.2,140.4,64.4 M145.3,64.4c0,1.5-0.3,2.8-0.8,4c-0.5,1.2-1.2,2.3-2.1,3.1   c-0.9,0.9-2,1.5-3.2,2c-1.2,0.5-2.6,0.7-4,0.7c-1.5,0-2.8-0.2-4-0.7c-1.2-0.5-2.3-1.1-3.2-2c-0.9-0.9-1.6-1.9-2.1-3.1   c-0.5-1.2-0.8-2.6-0.8-4c0-1.5,0.3-2.8,0.8-4c0.5-1.2,1.2-2.2,2.1-3.1c0.9-0.8,2-1.5,3.2-1.9c1.2-0.5,2.6-0.7,4-0.7   c1.5,0,2.8,0.2,4,0.7c1.2,0.5,2.3,1.1,3.2,1.9c0.9,0.8,1.6,1.9,2.1,3.1C145,61.6,145.3,62.9,145.3,64.4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M157.7,60.9c0-0.4-0.1-0.8-0.3-1.1c-0.2-0.3-0.4-0.5-0.7-0.6c-0.3-0.1-0.6-0.3-1-0.3c-0.4-0.1-0.7-0.1-1-0.1   h-2.4v4.3h2.1c0.4,0,0.7,0,1.1-0.1c0.4-0.1,0.7-0.2,1.1-0.3c0.3-0.2,0.6-0.4,0.8-0.7C157.6,61.7,157.7,61.3,157.7,60.9 M157.9,73.8   l-4-7.4h-1.5v7.4h-4.4V55.2h7.1c0.9,0,1.8,0.1,2.6,0.3c0.8,0.2,1.6,0.5,2.3,0.9c0.7,0.4,1.2,1,1.6,1.7c0.4,0.7,0.6,1.6,0.6,2.7   c0,1.3-0.3,2.3-1,3.2c-0.7,0.9-1.6,1.5-2.8,1.8l4.9,8H157.9z"
  }))), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "165.4,55.2 165.4,73.8 178.3,73.8 178.3,69.9 169.7,69.9 169.7,66.1 177.4,66.1 177.4,62.5 169.7,62.5   169.7,59 177.9,59 177.9,55.2 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "193.9,55.2 194,67.3 193.9,67.3 186.4,55.2 181.3,55.2 181.3,73.8 185.7,73.8 185.6,61.6 185.6,61.6   193.1,73.8 198.2,73.8 198.2,55.2 "
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 202.1,
    y: 55.2,
    className: "st1",
    width: 4.5,
    height: 18.6
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "223,55.2 223.1,67.3 223,67.3 215.6,55.2 210.4,55.2 210.4,73.8 214.8,73.8 214.7,61.6 214.8,61.6   222.3,73.8 227.4,73.8 227.4,55.2 "
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: 0,
    width: 260,
    height: 74.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M244.3,73.8c-1.2,0.3-2.5,0.4-4,0.4c-1.5,0-2.9-0.2-4.1-0.7c-1.3-0.5-2.3-1.1-3.2-2c-0.9-0.9-1.6-1.9-2.1-3.1   c-0.5-1.2-0.8-2.5-0.8-4c0-1.5,0.3-2.8,0.8-4c0.5-1.2,1.2-2.2,2.1-3.1c0.9-0.9,2-1.5,3.2-2c1.2-0.5,2.5-0.7,4-0.7   c1.5,0,2.8,0.2,4.1,0.7c1.3,0.4,2.3,1,3.1,1.8l-2.8,3.2c-0.4-0.5-1-0.9-1.7-1.2c-0.7-0.3-1.5-0.5-2.4-0.5c-0.8,0-1.5,0.1-2.2,0.4   c-0.7,0.3-1.2,0.7-1.7,1.2c-0.5,0.5-0.9,1.1-1.1,1.8c-0.3,0.7-0.4,1.5-0.4,2.3c0,0.9,0.1,1.6,0.4,2.4c0.2,0.7,0.6,1.3,1.1,1.9   c0.5,0.5,1.1,0.9,1.8,1.2c0.7,0.3,1.5,0.4,2.4,0.4c0.5,0,1,0,1.5-0.1c0.5-0.1,0.9-0.2,1.3-0.4v-3.4h-3.5v-3.6h7.7v9.9   C246.6,73.1,245.5,73.5,244.3,73.8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M35.6,5.1c-2.3-2.3-7.5-1-11.7,3.1c-4.2,4.1-5.7,9.3-3.4,11.6c2.3,2.3,7.5,1,11.7-3.1   C36.4,12.6,37.9,7.5,35.6,5.1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M53.2,0.5c0,7.5-4.5,17-12.6,24.8c-12,11.7-27.3,15.5-34.2,8.4c-6.8-6.9-2.9-21.7,8.5-33.3l9.4,0   c-1.6,1.2-3.3,2.5-4.8,4.1C10.6,13.2,7.1,24,11.6,28.7c4.5,4.6,15.4,1.4,24.3-7.3c7.2-7,10.9-15.5,9.6-20.9L53.2,0.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,11.4C2.5,7.1,5.4,2.8,8.5,0.5H0V11.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M69.7,0.5c-2.3,10.4-9.8,23-21.2,34.1C31.1,51.6,10.6,59.4,0,53.7l0-6.5c10.2,4.4,28.3-2.4,43.5-17.2   C53.2,20.5,59.7,9.7,62,0.5L69.7,0.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M77.8,0.5C75,12.5,66.3,27.1,53,40C34.5,58.2,13,67.4,0,64v9.9h100.1V0.5L77.8,0.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M260,60.2c-3.1,5.5-6.7,10.8-10.6,13.7H260V60.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M89.8,12.2c0-0.4-0.1-0.7-0.3-1c-0.2-0.2-0.4-0.4-0.7-0.6c-0.3-0.1-0.6-0.2-0.9-0.3s-0.6-0.1-1-0.1h-2.2v4h2   c0.3,0,0.7,0,1-0.1c0.4-0.1,0.7-0.2,1-0.3s0.5-0.4,0.7-0.6C89.7,13,89.8,12.7,89.8,12.2 M90,24l-3.7-6.7h-1.4V24h-4V7h6.5   c0.8,0,1.6,0.1,2.4,0.3c0.8,0.2,1.5,0.5,2.1,0.9c0.6,0.4,1.1,0.9,1.5,1.6c0.4,0.7,0.6,1.5,0.6,2.4c0,1.2-0.3,2.1-0.9,2.9   c-0.6,0.8-1.5,1.3-2.6,1.7l4.4,7.3H90z"
  }))), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "90.7,45 84.4,34.8 84.3,34.8 84.4,45 80.8,45 80.8,29.4 85.1,29.4 91.3,39.6 91.4,39.6 91.3,29.4   94.9,29.4 94.9,45 "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "85,52.5 85,56 91.5,56 91.5,59.4 85,59.4 85,66 80.9,66 80.9,49 92.1,49 92.1,52.5 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRnf);
export default __webpack_public_path__ + "static/media/RNF.32471ad1ab230d248b9c4f75ec5fd9cc.svg";
export { ForwardRef as ReactComponent };